import { useLanguage } from '../context/LanguageContext'

function CTASection() {
  const { t } = useLanguage()

  const ctaCards = [
    {
      href: null,
      bg: '/wp-content/uploads/2025/06/category-footer2-webp.webp',
      title: t('cta.buying'),
      label: t('cta.findOut'),
    },
    {
      href: '/sell-rent',
      bg: '/wp-content/uploads/2025/06/category-footer3-webp.webp',
      title: t('cta.selling'),
      label: t('cta.findOut'),
    },
    {
      href: '/sell-rent',
      bg: '/wp-content/uploads/2025/06/category-footer-webp-1024x682.webp',
      title: 'Start leasing',
      description: 'Explore premium rental properties or let our experts manage your lease.',
      label: t('cta.findOut'),
    },
  ]

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      minHeight: '450px',
    }}
      className="palmora-cta-row"
    >
      {ctaCards.map((card) => {
        const Tag = card.href ? 'a' : 'div'
        const linkProps = card.href
          ? { href: card.href }
          : { style: { cursor: 'default' } }

        return (
          <div key={card.title} style={{ flex: '1 1 0', position: 'relative', overflow: 'hidden' }}>
            <Tag
              className="elementor-cta"
              {...linkProps}
              style={{ display: 'block', position: 'relative', height: '100%', minHeight: '450px', overflow: 'hidden' }}
            >
              <div className="elementor-cta__bg-wrapper" style={{ position: 'absolute', inset: 0 }}>
                <div
                  className="elementor-cta__bg elementor-bg"
                  style={{
                    backgroundImage: `url(${card.bg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'absolute',
                    inset: 0,
                    filter: 'brightness(52%)',
                    transition: 'transform 1.6s ease',
                  }}
                />
                <div className="elementor-cta__bg-overlay" style={{ position: 'absolute', inset: 0, mixBlendMode: 'multiply' }} />
              </div>

              <div className="elementor-cta__content" style={{
                position: 'relative',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '450px',
                textAlign: 'center',
                padding: '40px 20px',
              }}>
                <h3 className="elementor-cta__title" style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: 'clamp(26px, 4vw, 47px)',
                  fontWeight: 500,
                  color: '#FFFFFF',
                  margin: card.description ? '0 0 15px 0' : '0 0 50px 0',
                }}>
                  {card.title}
                </h3>
                {card.description && (
                  <p style={{
                    color: '#fff',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '15px',
                    margin: '0 0 35px 0',
                    maxWidth: '85%',
                    opacity: 0.9,
                    lineHeight: '1.4'
                  }}>
                    {card.description}
                  </p>
                )}
                <div className="elementor-cta__button-wrapper">
                  <span className="elementor-cta__button elementor-button" style={{
                    display: 'inline-block',
                    border: '1px solid #FFFFFF',
                    color: '#FFFFFF',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '15px',
                    fontWeight: 400,
                    borderRadius: '5px',
                    padding: '10px 20px',
                    cursor: card.href ? 'pointer' : 'default',
                    opacity: card.href ? 1 : 0.6,
                  }}>
                    {card.href ? card.label : t('cta.comingSoon')}
                  </span>
                </div>
              </div>
            </Tag>
          </div>
        )
      })}

      <style>{`
        .palmora-cta-row a:hover .elementor-cta__bg { transform: scale(1.08); transform-origin: center center; }
        @media (max-width: 767px) {
          .palmora-cta-row { flex-direction: column !important; min-height: unset !important; }
          .palmora-cta-row > div { flex: unset !important; }
          .palmora-cta-row .elementor-cta { min-height: 260px !important; }
          .palmora-cta-row .elementor-cta__content { min-height: 260px !important; }
          .palmora-cta-row h3.elementor-cta__title { font-size: clamp(22px, 6vw, 35px) !important; margin-bottom: 24px !important; }
        }
      `}</style>
    </div>
  )
}

export default CTASection
